// import React, { useEffect, useState } from 'react'
// import { createPlanOrder, getAllPlans, getMyPlans, verifyPayment } from './ApiFunction';
// import { message } from 'antd';

// const PlanManagement = () => {
//     const [allPlans, setAllPlans] = useState([]);
//     const [myPlans, setMyPlans] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [activeTab, setActiveTab] = useState("plans");

//     const GetAllPlans = () => {
//         setLoading(true);
//         getAllPlans().then((res) => {
//             if (res.status === "success") {
//                 setAllPlans(res?.data);
//                 setLoading(false);
//             } else {
//                 message.error(res.error);
//             }
//         }).catch((err) => {
//             message.error(err.message || "something went wrong");
//         }).finally(() => {
//             setLoading(false);
//         })
//     }
//     const GetMyPlans = () => {
//         setLoading(true);
//         getMyPlans().then((res) => {
//             if (res.status === "success") {
//                 setMyPlans(res?.data);
//                 setLoading(false);
//             } else {
//                 message.error(res.error);
//             }
//         }).catch((err) => {
//             message.error(err.message || "something went wrong");
//         }).finally(() => {
//             setLoading(false);
//         })
//     }
//     useEffect(() => {
//         GetAllPlans();
//         GetMyPlans();
//     }, []);
//     const handleBuyPlan = async (plan) => {
//         try {

//             setLoading(true);

//             const res = await createPlanOrder({
//                 plan_id: plan.id
//             });

//             console.log(res);
//             const order = res.data;

//             const options = {
//                 key: order.razorpay_key,
//                 amount: order.amount,
//                 currency: order.currency,
//                 name: "DineValts",
//                 description: order.plan.name,
//                 order_id: order.order_id,

//                 handler: async function (response) {

//                     console.log("Payment Success", response);

//                     try {

//                         const verifyRes = await verifyPayment({
//                             razorpay_order_id: response.razorpay_order_id,
//                             razorpay_payment_id: response.razorpay_payment_id,
//                             razorpay_signature: response.razorpay_signature,
//                         });

//                         console.log("Verify Response", verifyRes);

//                         if (verifyRes.status === "success") {

//                             message.success("Payment Verified Successfully");
//                             GetMyPlans();

//                         } else {

//                             message.error(verifyRes.message);

//                         }

//                     } catch (err) {

//                         console.log(err);
//                         message.error("Payment Verification Failed");

//                     }

//                 },

//                 theme: {
//                     color: "#4F46E5",
//                 },
//             };
//             const razorpay = new window.Razorpay(options);

//             razorpay.on("payment.failed", function (response) {
//                 console.log("Payment Failed", response);
//                 message.error(response.error.description);
//             });

//             razorpay.open();

//         } catch (err) {

//             message.error(err.message);

//         } finally {

//             setLoading(false);

//         }
//     };

//     return (
//         <>
//             <div className="max-w-7xl mx-auto px-6 py-12">
//                 <div className="flex bg-gray-100 rounded-xl p-1 w-fit mb-8">
//                     <button
//                         onClick={() => setActiveTab("plans")}
//                         className={`px-6 py-3 rounded-lg font-semibold transition ${activeTab === "plans"
//                             ? "bg-white shadow text-indigo-600"
//                             : "text-gray-500"
//                             }`}
//                     >
//                         All Plans
//                     </button>

//                     <button
//                         onClick={() => setActiveTab("myplans")}
//                         className={`px-6 py-3 rounded-lg font-semibold transition ${activeTab === "myplans"
//                             ? "bg-white shadow text-indigo-600"
//                             : "text-gray-500"
//                             }`}
//                     >
//                         My Plans
//                     </button>
//                 </div>
//                 {
//                     activeTab === "plans"
//                         ? <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
//                             {allPlans?.map((plan) => (
//                                 <div
//                                     key={plan.id}
//                                     className="relative bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-xl transition-all duration-300 p-7 flex flex-col"
//                                 >
//                                     {/* Plan Type */}
//                                     <span className="absolute top-5 right-5 bg-indigo-100 text-indigo-600 text-xs font-semibold px-3 py-1 rounded-full uppercase">
//                                         {plan.plan_type}
//                                     </span>

//                                     {/* Plan Name */}
//                                     <h3 className="text-2xl font-bold text-gray-900">
//                                         {plan.name}
//                                     </h3>

//                                     <p className="text-gray-500 mt-2 text-sm">
//                                         {plan.description}
//                                     </p>

//                                     {/* Price */}
//                                     <div className="mt-6">
//                                         <span className="text-5xl font-bold text-gray-900">
//                                             ₹{Number(plan.price).toLocaleString()}
//                                         </span>
//                                         <span className="text-gray-500 ml-2">
//                                             / {plan.duration_days} Days
//                                         </span>
//                                     </div>

//                                     {/* Limits */}
//                                     <div className="mt-6 space-y-3 text-sm text-gray-700">
//                                         <div className="flex justify-between">
//                                             <span>Restaurants</span>
//                                             <span className="font-semibold">
//                                                 {plan.max_restaurants ?? "Unlimited"}
//                                             </span>
//                                         </div>

//                                         <div className="flex justify-between">
//                                             <span>Tables / Restaurant</span>
//                                             <span className="font-semibold">
//                                                 {plan.max_tables_per_restaurant ?? "Unlimited"}
//                                             </span>
//                                         </div>
//                                     </div>

//                                     {/* Features */}
//                                     <div className="mt-8">
//                                         <h4 className="font-semibold text-gray-900 mb-4">
//                                             Features
//                                         </h4>

//                                         <ul className="space-y-3">
//                                             {plan?.features?.map((feature, index) => (
//                                                 <li
//                                                     key={index}
//                                                     className="flex items-center gap-3 text-gray-600"
//                                                 >
//                                                     <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-100 text-green-600 text-xs">
//                                                         ✓
//                                                     </span>

//                                                     {feature}
//                                                 </li>
//                                             ))}
//                                         </ul>
//                                     </div>

//                                     {/* Button */}
//                                     <button
//                                         onClick={() => handleBuyPlan(plan)}
//                                         className="mt-8 w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-xl transition"
//                                     >
//                                         Buy Now
//                                     </button>
//                                 </div>
//                             ))}
//                         </div>
//                         : <div>
//                             {
//                                 myPlans.has_active_plan ? (
//                                     <div className="rounded-3xl bg-gradient-to-r from-indigo-600 to-violet-600 text-white p-8 shadow-xl">

//                                         <div className="flex justify-between items-center mb-6">
//                                             <div>
//                                                 <h2 className="text-3xl font-bold">
//                                                     {myPlans.active_plan.plan_name}
//                                                 </h2>

//                                                 <p className="opacity-90 mt-2">
//                                                     {myPlans.active_plan.description}
//                                                 </p>
//                                             </div>

//                                             <span className="bg-green-500 px-4 py-2 rounded-full text-sm font-semibold">
//                                                 ACTIVE
//                                             </span>
//                                         </div>

//                                         <div className="grid md:grid-cols-4 gap-6 mt-8">

//                                             <div>
//                                                 <p className="text-sm opacity-70">Start Date</p>
//                                                 <h4 className="font-semibold">
//                                                     {new Date(myPlans.active_plan.start_date).toLocaleDateString()}
//                                                 </h4>
//                                             </div>

//                                             <div>
//                                                 <p className="text-sm opacity-70">Expiry Date</p>
//                                                 <h4 className="font-semibold">
//                                                     {new Date(myPlans.active_plan.end_date).toLocaleDateString()}
//                                                 </h4>
//                                             </div>

//                                             <div>
//                                                 <p className="text-sm opacity-70">Remaining</p>
//                                                 <h4 className="font-semibold">
//                                                     {myPlans.active_plan.days_remaining} Days
//                                                 </h4>
//                                             </div>

//                                             <div>
//                                                 <p className="text-sm opacity-70">Plan Type</p>
//                                                 <h4 className="font-semibold uppercase">
//                                                     {myPlans.active_plan.plan_type}
//                                                 </h4>
//                                             </div>

//                                         </div>

//                                         <div className="grid md:grid-cols-2 gap-8 mt-8">

//                                             <div>
//                                                 <p className="text-sm opacity-70 mb-2">Restaurants</p>

//                                                 <h3 className="text-xl font-bold">
//                                                     {myPlans.active_plan.max_restaurants ?? "Unlimited"}
//                                                 </h3>
//                                             </div>

//                                             <div>
//                                                 <p className="text-sm opacity-70 mb-2">Tables Per Restaurant</p>

//                                                 <h3 className="text-xl font-bold">
//                                                     {myPlans.active_plan.max_tables_per_restaurant ??
//                                                         "Unlimited"}
//                                                 </h3>
//                                             </div>

//                                         </div>

//                                         <div className="mt-8">

//                                             <h3 className="text-xl font-semibold mb-4">
//                                                 Features
//                                             </h3>

//                                             <div className="grid md:grid-cols-2 gap-3">

//                                                 {myPlans?.active_plan?.features?.map((feature, index) => (

//                                                     <div
//                                                         key={index}
//                                                         className="flex items-center gap-3 bg-white/10 rounded-lg p-3"
//                                                     >
//                                                         ✅ {feature}
//                                                     </div>

//                                                 ))}

//                                             </div>

//                                         </div>

//                                     </div>
//                                 ) : (
//                                     <div className="bg-white rounded-2xl shadow p-10 text-center">

//                                         <h2 className="text-2xl font-bold">
//                                             No Active Plan
//                                         </h2>

//                                         <p className="text-gray-500 mt-2">
//                                             Purchase a subscription to continue.
//                                         </p>

//                                     </div>
//                                 )
//                             }

//                             <div className='mt-6'>
//                                 <h2 className="text-2xl font-bold mb-6">
//                                     Subscription History
//                                 </h2>

//                                 <div className="space-y-5">

//                                     {myPlans?.plan_history?.map((history) => (

//                                         <div
//                                             key={history.id}
//                                             className="bg-white rounded-2xl shadow-md border p-6 hover:shadow-lg transition"
//                                         >

//                                             <div className="flex justify-between items-start">

//                                                 <div>

//                                                     <h3 className="text-xl font-semibold">
//                                                         {history.plan.name}
//                                                     </h3>

//                                                     <p className="text-gray-500 mt-1">
//                                                         {history.plan.plan_type.toUpperCase()} • ₹
//                                                         {history.amount_paid}
//                                                     </p>

//                                                 </div>

//                                                 <span
//                                                     className={`px-4 py-1 rounded-full text-sm font-semibold
//                                                         ${history.status === "active"
//                                                             ? "bg-green-100 text-green-700"
//                                                             : "bg-red-100 text-red-600"
//                                                         }`}
//                                                 >
//                                                     {history.status.toUpperCase()}
//                                                 </span>

//                                             </div>

//                                             <div className="grid md:grid-cols-4 gap-5 mt-6">

//                                                 <div>
//                                                     <p className="text-sm text-gray-400">Start</p>
//                                                     <p>
//                                                         {new Date(history.start_date).toLocaleDateString()}
//                                                     </p>
//                                                 </div>

//                                                 <div>
//                                                     <p className="text-sm text-gray-400">End</p>
//                                                     <p>
//                                                         {new Date(history.end_date).toLocaleDateString()}
//                                                     </p>
//                                                 </div>

//                                                 <div>
//                                                     <p className="text-sm text-gray-400">Payment Ref.</p>
//                                                     <p>{history.payment_reference || "--"}</p>
//                                                 </div>

//                                                 <div>
//                                                     <p className="text-sm text-gray-400">Amount</p>
//                                                     <p>₹{history.amount_paid}</p>
//                                                 </div>

//                                             </div>

//                                             {history.notes && (
//                                                 <div className="mt-5 bg-gray-50 border rounded-lg p-4">

//                                                     <p className="text-sm text-gray-500">
//                                                         Notes
//                                                     </p>

//                                                     <p className="mt-1">
//                                                         {history.notes}
//                                                     </p>

//                                                 </div>
//                                             )}

//                                         </div>

//                                     ))}

//                                 </div>

//                             </div>
//                         </div>
//                 }

//             </div>
//         </>
//     )
// }

// export default PlanManagement;


import React, { useEffect, useState } from 'react'
import { createPlanOrder, getAllPlans, getMyPlans, verifyPayment } from './ApiFunction';
import { message } from 'antd';

const PlanManagement = () => {
    const [allPlans, setAllPlans] = useState([]);
    const [myPlans, setMyPlans] = useState({});
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("plans");

    const GetAllPlans = () => {
        setLoading(true);
        getAllPlans().then((res) => {
            if (res.status === "success") {
                setAllPlans(res?.data || []);
            } else {
                message.error(res.error || "Failed to load plans");
            }
        }).catch((err) => {
            message.error(err.message || "something went wrong");
        }).finally(() => {
            setLoading(false);
        })
    }

    const GetMyPlans = () => {
        setLoading(true);
        getMyPlans().then((res) => {
            if (res.status === "success") {
                setMyPlans(res?.data || {});
            } else {
                message.error(res.error || "Failed to load your plans");
            }
        }).catch((err) => {
            message.error(err.message || "something went wrong");
        }).finally(() => {
            setLoading(false);
        })
    }

    useEffect(() => {
        GetAllPlans();
        GetMyPlans();
    }, []);

    const handleBuyPlan = async (plan) => {
        try {
            setLoading(true);

            const res = await createPlanOrder({ plan_id: plan.id });
            const order = res.data;

            const options = {
                key: order.razorpay_key,
                amount: order.amount,
                currency: order.currency,
                name: "DineValts",
                description: order.plan.name,
                order_id: order.order_id,

                handler: async function (response) {
                    try {
                        const verifyRes = await verifyPayment({
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature,
                        });

                        if (verifyRes.status === "success") {
                            message.success("Payment Verified Successfully");
                            GetMyPlans();
                        } else {
                            message.error(verifyRes.message);
                        }
                    } catch (err) {
                        console.log(err);
                        message.error("Payment Verification Failed");
                    }
                },

                theme: { color: "#4F46E5" },
            };

            const razorpay = new window.Razorpay(options);

            razorpay.on("payment.failed", function (response) {
                console.log("Payment Failed", response);
                message.error(response.error.description);
            });

            razorpay.open();
        } catch (err) {
            message.error(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Helper to render status badge with proper colors
    const renderStatusBadge = (status) => {
        const s = String(status || "").toLowerCase();
        const colorMap = {
            active: "bg-green-100 text-green-700",
            cancelled: "bg-red-100 text-red-600",
            expired: "bg-gray-100 text-gray-600",
            pending: "bg-amber-100 text-amber-700",
        };
        const cls = colorMap[s] || "bg-gray-100 text-gray-600";
        return (
            <span className={`px-4 py-1 rounded-full text-sm font-semibold ${cls}`}>
                {s.toUpperCase()}
            </span>
        );
    };

    return (
        <>
            <div className="max-w-7xl mx-auto px-6 py-12">
                <div className="flex bg-gray-100 rounded-xl p-1 w-fit mb-8">
                    <button
                        onClick={() => setActiveTab("plans")}
                        className={`px-6 py-3 rounded-lg font-semibold transition ${activeTab === "plans"
                            ? "bg-white shadow text-indigo-600"
                            : "text-gray-500"
                            }`}
                    >
                        All Plans
                    </button>

                    <button
                        onClick={() => setActiveTab("myplans")}
                        className={`px-6 py-3 rounded-lg font-semibold transition ${activeTab === "myplans"
                            ? "bg-white shadow text-indigo-600"
                            : "text-gray-500"
                            }`}
                    >
                        My Plans
                    </button>
                </div>

                {activeTab === "plans" ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
                        {allPlans?.map((plan) => {
                            const basePrice = Number(plan.price ?? 0);
                            const totalPrice = Number(plan.price_with_gst ?? plan.price ?? 0);
                            const gst = plan.gst_percentage;
                            const isFree = plan.plan_type === "free" || basePrice === 0;

                            return (
                                <div
                                    key={plan.id}
                                    className="relative bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-xl transition-all duration-300 p-7 flex flex-col"
                                >
                                    {/* Plan Type */}
                                    <span className="absolute top-5 right-5 bg-indigo-100 text-indigo-600 text-xs font-semibold px-3 py-1 rounded-full uppercase">
                                        {plan.plan_type}
                                    </span>

                                    {/* Plan Name */}
                                    <h3 className="text-2xl font-bold text-gray-900">
                                        {plan.name}
                                    </h3>

                                    <p className="text-gray-500 mt-2 text-sm">
                                        {plan.description}
                                    </p>

                                    {/* Price (headline shows total including GST) */}
                                    <div className="mt-6">
                                        <div className="flex items-baseline">
                                            <span className="text-4xl font-bold text-gray-900">
                                                ₹{totalPrice.toLocaleString()}
                                            </span>
                                            <span className="text-gray-500 ml-2">
                                                / {plan.duration_days} Days
                                            </span>
                                        </div>

                                        {!isFree && gst && (
                                            <div className="mt-1 text-xs text-gray-500">
                                                Base: ₹{basePrice.toLocaleString()} • +{gst}% GST
                                            </div>
                                        )}
                                    </div>

                                    {/* Limits */}
                                    <div className="mt-6 space-y-3 text-sm text-gray-700">
                                        <div className="flex justify-between">
                                            <span>Restaurants</span>
                                            <span className="font-semibold">
                                                {plan.max_restaurants ?? "Unlimited"}
                                            </span>
                                        </div>

                                        <div className="flex justify-between">
                                            <span>Tables / Restaurant</span>
                                            <span className="font-semibold">
                                                {plan.max_tables_per_restaurant ?? "Unlimited"}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Features */}
                                    <div className="mt-8">
                                        <h4 className="font-semibold text-gray-900 mb-4">
                                            Features
                                        </h4>

                                        <ul className="space-y-3">
                                            {plan?.features?.map((feature, index) => (
                                                <li
                                                    key={index}
                                                    className="flex items-center gap-3 text-gray-600"
                                                >
                                                    <span className="flex items-center justify-center w-5 h-5 rounded-full bg-green-100 text-green-600 text-xs">
                                                        ✓
                                                    </span>
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>

                                    {/* Button */}
                                    <button
                                        onClick={() => handleBuyPlan(plan)}
                                        className="mt-8 w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-xl transition"
                                    >
                                        Buy Now
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div>
                        {myPlans?.has_active_plan ? (
                            <div className="rounded-3xl bg-gradient-to-r from-indigo-600 to-violet-600 text-white p-8 shadow-xl">
                                <div className="flex justify-between items-center mb-6">
                                    <div>
                                        <h2 className="text-3xl font-bold">
                                            {myPlans.active_plan.plan_name}
                                        </h2>
                                        <p className="opacity-90 mt-2">
                                            {myPlans.active_plan.description}
                                        </p>
                                    </div>
                                    <span className="bg-green-500 px-4 py-2 rounded-full text-sm font-semibold">
                                        ACTIVE
                                    </span>
                                </div>

                                <div className="grid md:grid-cols-4 gap-6 mt-8">
                                    <div>
                                        <p className="text-sm opacity-70">Start Date</p>
                                        <h4 className="font-semibold">
                                            {new Date(myPlans.active_plan.start_date).toLocaleDateString()}
                                        </h4>
                                    </div>
                                    <div>
                                        <p className="text-sm opacity-70">Expiry Date</p>
                                        <h4 className="font-semibold">
                                            {new Date(myPlans.active_plan.end_date).toLocaleDateString()}
                                        </h4>
                                    </div>
                                    <div>
                                        <p className="text-sm opacity-70">Remaining</p>
                                        <h4 className="font-semibold">
                                            {myPlans.active_plan.days_remaining} Days
                                        </h4>
                                    </div>
                                    <div>
                                        <p className="text-sm opacity-70">Plan Type</p>
                                        <h4 className="font-semibold uppercase">
                                            {myPlans.active_plan.plan_type}
                                        </h4>
                                    </div>
                                </div>

                                <div className="grid md:grid-cols-3 gap-8 mt-8">
                                    <div>
                                        <p className="text-sm opacity-70 mb-2">Restaurants</p>
                                        <h3 className="text-xl font-bold">
                                            {myPlans.active_plan.max_restaurants ?? "Unlimited"}
                                        </h3>
                                    </div>
                                    <div>
                                        <p className="text-sm opacity-70 mb-2">Tables Per Restaurant</p>
                                        <h3 className="text-xl font-bold">
                                            {myPlans.active_plan.max_tables_per_restaurant ?? "Unlimited"}
                                        </h3>
                                    </div>
                                    <div>
                                        <p className="text-sm opacity-70 mb-2">Total Paid</p>
                                        <h3 className="text-xl font-bold">
                                            ₹{myPlans.active_plan.total_amount_paid ?? myPlans.active_plan.amount_paid ?? "--"}
                                        </h3>
                                        {myPlans.active_plan.gst_percentage && (
                                            <p className="text-xs opacity-70 mt-1">
                                                incl. {myPlans.active_plan.gst_percentage}% GST
                                            </p>
                                        )}
                                    </div>
                                </div>

                                <div className="mt-8">
                                    <h3 className="text-xl font-semibold mb-4">Features</h3>
                                    <div className="grid md:grid-cols-2 gap-3">
                                        {myPlans?.active_plan?.features?.map((feature, index) => (
                                            <div
                                                key={index}
                                                className="flex items-center gap-3 bg-white/10 rounded-lg p-3"
                                            >
                                                ✅ {feature}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="bg-white rounded-2xl shadow p-10 text-center">
                                <h2 className="text-2xl font-bold">No Active Plan</h2>
                                <p className="text-gray-500 mt-2">
                                    Purchase a subscription to continue.
                                </p>
                            </div>
                        )}

                        <div className='mt-6'>
                            <h2 className="text-2xl font-bold mb-6">
                                Subscription History
                            </h2>

                            {myPlans?.plan_history?.length ? (
                                <div className="space-y-5">
                                    {myPlans.plan_history.map((history) => {
                                        const basePrice = Number(history.amount_paid ?? 0);
                                        const totalPaid = Number(history.total_amount_paid ?? history.amount_paid ?? 0);
                                        const gstPct = history.gst_percentage ?? history.plan?.gst_percentage;
                                        const gstAmt = history.gst_amount;

                                        return (
                                            <div
                                                key={history.id}
                                                className="bg-white rounded-2xl shadow-md border p-6 hover:shadow-lg transition"
                                            >
                                                <div className="flex justify-between items-start">
                                                    <div>
                                                        <h3 className="text-xl font-semibold">
                                                            {history.plan?.name || "Plan"}
                                                        </h3>
                                                        <p className="text-gray-500 mt-1">
                                                            {String(history.plan?.plan_type || history.plan_type || "").toUpperCase()} • ₹{totalPaid}
                                                        </p>
                                                    </div>
                                                    {renderStatusBadge(history.status)}
                                                </div>

                                                <div className="grid md:grid-cols-4 gap-5 mt-6">
                                                    <div>
                                                        <p className="text-sm text-gray-400">Start</p>
                                                        <p>
                                                            {new Date(history.start_date).toLocaleDateString()}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm text-gray-400">End</p>
                                                        <p>
                                                            {new Date(history.end_date).toLocaleDateString()}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm text-gray-400">Payment Ref.</p>
                                                        <p className="truncate" title={history.payment_reference}>
                                                            {history.payment_reference || "--"}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className="text-sm text-gray-400">Amount Paid</p>
                                                        <p className="font-semibold">₹{totalPaid}</p>
                                                        {gstPct && basePrice > 0 && (
                                                            <p className="text-xs text-gray-400 mt-0.5">
                                                                Base ₹{basePrice} + {gstPct}% GST
                                                                {gstAmt ? ` (₹${gstAmt})` : ""}
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>

                                                {history.notes && (
                                                    <div className="mt-5 bg-gray-50 border rounded-lg p-4">
                                                        <p className="text-sm text-gray-500">Notes</p>
                                                        <p className="mt-1">{history.notes}</p>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="bg-white rounded-2xl shadow border p-8 text-center text-gray-500">
                                    No subscription history available.
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default PlanManagement;